/* eslint-disable max-len */
export var TimeType;

(function (TimeType) {
  TimeType["END"] = "endTime";
  TimeType["START"] = "startTime";
})(TimeType || (TimeType = {}));
//# sourceMappingURL=types.js.map